import React from 'react';
import PropTypes from 'prop-types';
import Router from 'sites/routes/router';
import { push } from 'connected-react-router';
import { types, RECORD_KEEPING } from './data';
import intercomMoreInfo, { MEMBER_SUPPORT } from 'sites/utils/IntercomMoreInfo';
// import { isLukespov, isRiggsfilms } from 'sites/utils/Helpers';
import { getSiteNameAbbreviatur, getSiteLink } from 'common/utils/helper';
import mmsLogoLight from 'assets/images/mymembersite-logo-light.svg'
import mmsLogoDark from 'assets/images/mymembersite-logo-dark.svg'
import { useDispatch } from 'react-redux';
import rtaLogoDark from 'assets/images/rta-logo-dark.svg'
import rtaLogoLight from 'assets/images/rta-logo-light.svg'
import classNames from 'classnames';
import { filterBadWords } from 'common/utils/filter-bad-words';


const InformationAndPolices = ({
   footerPoweredByText,
   refCode,
   openSecondModal,
   isAffiliateEnabled,
   affiliateLink,
   legalPages,
   customFooterLinks,
   showLightLogo,
   isBrandingRemoval,
   children,
   hideInformationAndPoliciesLinks,
   isAgeVerificationRequired,
   showWorkFactionText,
   avaliablePaymentMethodsView,
}) => {
   const dispatch = useDispatch()
   let currentInfo

   if(!!legalPages && !!legalPages?.length) {
      currentInfo = legalPages?.find(it => it.name === 'ccbill')
   }

   return (
      <div className='select-none text-sm mb-6 md:mb-8 flex flex-col items-center px-4 dk-footer' style={ { lineHeight: '16px' } }>
         <div
            className={ classNames({
               'text-center': true,
               'mb-[12px]': !hideInformationAndPoliciesLinks,
            }) }
         >
            {
               !!(footerPoweredByText?.trim()) ? (
                  <span className='text-secondary dark:text-secondary-dark '>{footerPoweredByText} </span>
               ) : (
                  <>
                     {
                        !isBrandingRemoval && (
                           <a className='skin-primary-text hover:underline font-medium tracking-[0.001em]' target='_blank' rel='noopener noreferrer' href={ `${ getSiteLink() }?ref=rf${ refCode }` }>
                              {/* {getCapitalizeSiteName()} */}
                              <img src={ showLightLogo ? mmsLogoLight : (window?.site_dark_bg ? mmsLogoDark : mmsLogoLight) } className='w-[145px] h-5' alt='mmslogo' />
                           </a>
                        )
                     }
                  </>
               )
            }
         </div>
         {
            avaliablePaymentMethodsView
         }
         {
            !hideInformationAndPoliciesLinks && (
               <>
                  <div className='w-full flex flex-wrap items-center justify-center text-placeholder text-center tracking-[0.0025em]' style={ { fontSize: '10px' } } >
                     <span className='dark:text-placeholder-dark'>Charges through <a className='underline' target='_blank' rel='noopener noreferrer nofollow' href='https://support.ccbill.com/'>CCBill</a> will appear on your statement as CCBill.com *{currentInfo?.html_content ? (isAgeVerificationRequired ? filterBadWords(currentInfo?.html_content) : currentInfo?.html_content) : getSiteNameAbbreviatur()}</span>&nbsp;{'•'}&nbsp;
                     <span className='dark:text-placeholder-dark'>Please visit <a className='underline' target='_blank' rel='noopener noreferrer nofollow' href='https://cs.segpay.com/'>Segpay</a> , our authorized payment processor</span>&nbsp;{'•'}&nbsp;
                     <span className='dark:text-placeholder-dark'><a className='underline' target='_blank' rel='noopener noreferrer nofollow' href='https://epoch.com/billing_support'>Epoch.com</a> Billing Support</span>
                  </div>
                  <div className='text-placeholder flex flex-wrap text-center px-7 dark:text-placeholder-dark justify-center' style={ { lineHeight: '18px', fontSize: '10px' } }>
                     {
                        types.map((type, index) => {

                           if(type === "Affiliates" && !isAffiliateEnabled) {
                              return null
                           }

                           return <div
                              role='presentation'
                              className='cursor-pointer'
                              onClick={ () => {
                                 if(type === 'Affiliates') {
                                    window.open(affiliateLink, '_blank')
                                    return
                                 } else if(type === 'Contact Us') {
                                    dispatch(push(Router.route('CONTACT_US').getCompiledPath()));
                                 } else if(type === 'Member support') {
                                    intercomMoreInfo(MEMBER_SUPPORT)
                                 } else {
                                    openSecondModal(type)
                                 }
                              } }
                              key={ index.toString() }
                           >
                              {/*  */}
                              <span
                                 data-tooltip-content={ type === RECORD_KEEPING  ? '18 U.S.C. 2257 Record-Keeping Requirements Compliance Statement' : null }
                                 data-tooltip-id={ type === RECORD_KEEPING ? 'ams-top-tooltip' : null }
                                 className='hover:underline dark:text-placeholder-dark '
                              >{ type === RECORD_KEEPING ? ' §2257 Compliance' : type }</span> {index !== types.length - 1 && '•'}&nbsp;
                           </div>
                        })
                     }
                     {
                        customFooterLinks && customFooterLinks.map((link, index) => {
                           return (
                              <span
                                 key={ index }
                                 className='dark:text-secondary-dark '
                              >
                                 •&nbsp;<a
                                    className='underline'
                                    target='_blank'
                                    rel='noopener noreferrer nofollow'
                                    href={ link.link }
                                 >
                                    {isAgeVerificationRequired ? filterBadWords(link.display_name) : link.display_name}
                                 </a>&nbsp;
                              </span>
                           )
                        })
                     }
                     {/* {
                     (isLukespov() || isRiggsfilms()) && (
                        <>
                           <span className='dark:text-secondary-dark '>
                              •&nbsp;<a className='underline' target='_blank' rel='noopener noreferrer nofollow' href='http://freeones.com/'>freeones.com</a>
                           </span>
                           <span className='dark:text-secondary-dark '>
                               &nbsp;•&nbsp;<a className='underline' target='_blank' rel='noopener noreferrer nofollow' href='http://babepedia.com/'>babepedia.com</a>
                           </span>
                        </>
                     )
                  } */}
                  </div>
                  {
                     showWorkFactionText && (
                        <span style={ { fontSize: '10px' } } className='text-placeholder dark:text-placeholder-dark text-center tracking-[0.0025em]'>This content is a work of fiction performed by consenting adults. All individuals involved are professional actors, and the activities depicted are staged and consensual.</span>
                     )
                  }
                  <div className='mt-1'>
                     <img src={ window?.site_dark_bg ? rtaLogoDark : rtaLogoLight } className='w-[42px] h-[18px]' alt='rtalogo' />
                  </div>
                  {children}
               </>
            )
         }
      </div>
   )
}


InformationAndPolices.propTypes = {
   footerPoweredByText: PropTypes.string,
   refCode: PropTypes.string,
   openSecondModal: PropTypes.func,
   isAffiliateEnabled: PropTypes.bool,
   affiliateLink: PropTypes.string,
   legalPages: PropTypes.array,
   customFooterLinks: PropTypes.array,
   showLightLogo: PropTypes.bool,
   isBrandingRemoval: PropTypes.bool,
   children: PropTypes.any,
   hideInformationAndPoliciesLinks: PropTypes.bool,
   isAgeVerificationRequired: PropTypes.bool,
   showWorkFactionText: PropTypes.bool,
   avaliablePaymentMethodsView: PropTypes.any,
}

export default InformationAndPolices;
